import { reactive, toRefs } from 'vue'

function getDefaultState () {
  return {
    selectedReason: null,
    errorMessage: ''
  }
}

const state = reactive(getDefaultState())

function resetState () {
  Object.assign(state, getDefaultState())
}

export default toRefs(state)

export {
  resetState
}